import React from "react";

import Header from "../../components/Header";

import Questionario from "../../components/Questionarios/Questionario";

import {Context} from "../../AppProvider";

import { useLocation} from "react-router-dom";

import "./styles.css"

function TelaQuestionario(props) {
    const {state} = useLocation();
    let questionario = state.questionario;
    return (
        <Context.Consumer>
        {(context) => (
          <div>
            <Header usuario={context.usuario} videoajuda={props.videoajuda} />
            <Questionario usuario={context.usuario} questionario={questionario} />
          </div>
        )}
      </Context.Consumer>
    )
}

export default TelaQuestionario;